<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { cn } from '@shared/utils';

  export let link: string;
  export let target: '_blank' | undefined = undefined;
  export let classes: string | undefined = '';

  $: href = target === '_blank' ? link : `/${link}`;

  // @TODO - improve href & target logic + paths
</script>

<a {href} {target} class="{cn('group flex shrink-0 items-center gap-2 text-sm font-medium uppercase', classes)}">
  <span
    class="underline-group-hover after:bg-default-400 dark:after:bg-default-500 after:absolute after:-bottom-[1px] after:left-0 after:right-0 after:h-[1px]"
  >
    <slot />
  </span>

  <Icon name="arrow" height="{16}" width="{16}" classes="transition-transform group-hover:translate-x-1" />
</a>
